export const groupsManagement = {
    authorizedRoles: [],
};
